import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileMenu", "menuIconOpen", "menuIconClosed"]

  connect() {
    this.isOpen = false
  }

  toggleMenu() {
    this.isOpen = !this.isOpen
    
    if (this.hasMobileMenuTarget) {
      this.mobileMenuTarget.classList.toggle("hidden", !this.isOpen)
    }
    
    if (this.hasMenuIconOpenTarget && this.hasMenuIconClosedTarget) {
      this.menuIconOpenTarget.classList.toggle("hidden", !this.isOpen)
      this.menuIconClosedTarget.classList.toggle("hidden", this.isOpen)
    }
  }

  closeMenu() {
    this.isOpen = false
    if (this.hasMobileMenuTarget) {
      this.mobileMenuTarget.classList.add("hidden")
    }
    if (this.hasMenuIconOpenTarget && this.hasMenuIconClosedTarget) {
      this.menuIconOpenTarget.classList.add("hidden")
      this.menuIconClosedTarget.classList.remove("hidden")
    }
  }
}
